<template>
  <el-popover
    v-if="filteredExplain.length"
    placement="top"
    width="300"
    :title="$t('knowledge.search-admin.prompt-popover.title')"
    trigger="manual"
    visible-arrow
    v-model="visible"
    popper-class="prompt-popover"
    v-click-outside="closePopover"
  >
    <div class="prompt-body">
      <font-awesome-icon
        @click.prevent.stop="closePopover"
        class="close-icon"
        :icon="['fal', 'times']"
      ></font-awesome-icon>
      <div
        class="prompt-subtitle"
        v-html="
          sanitize(
            $tc(
              'knowledge.search-admin.prompt-popover.subtitle',
              highlights.length,
            ),
          )
        "
      ></div>
      <div class="prompt-callout">
        <span class="prompt-related">{{
          $t('knowledge.search-admin.prompt-popover.prompt-related')
        }}</span>
        <span v-html="sanitize(highlights[step])"></span>
      </div>
      <div v-if="highlights.length > 1" class="prompt-footer">
        <div class="prompt-count">
          {{
            $t('knowledge.search-admin.prompt-popover.occurrence', {
              counter: `${step + 1}/${highlights.length}`,
            })
          }}
        </div>
        <div>
          <el-button
            v-if="step > 0"
            @click="step -= 1"
            size="mini"
            plain
            type="secondary"
            >{{
              $t('knowledge.search-admin.prompt-popover.previous')
            }}</el-button
          >
          <el-button
            @click="step += 1"
            size="mini"
            type="primary"
            :disabled="step === highlights.length - 1"
            >{{ $t('knowledge.search-admin.prompt-popover.next') }}</el-button
          >
        </div>
      </div>
    </div>
    <el-tooltip
      slot="reference"
      :content="$t('knowledge.search-admin.prompt-popover.title')"
      placement="right"
      :disabled="visible"
    >
      <font-awesome-icon
        @click.prevent.stop="visible = !visible"
        :icon="['fad', 'info-circle']"
        class="info-icon mx-2 leading-min"
      />
    </el-tooltip>
  </el-popover>
</template>

<script>
import { sanitize } from '@/plugins/dompurify';

export default {
  name: 'explain-prompt',
  props: {
    explain: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
      step: 0,
      sanitize: sanitize,
    };
  },
  computed: {
    filteredExplain() {
      return this.explain.filter((exp) => exp.field === 'linkedContents');
    },
    highlights() {
      return this.filteredExplain[0].highlights;
    },
  },
  methods: {
    closePopover() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.info-icon {
  color: $grey-5-mayday;
  font-size: 12px;
}

.prompt-subtitle {
  margin-bottom: 6px;
  font-size: 14px;
  line-height: 1;
  word-break: break-word;
  text-align: left;

  :deep() .highlight-count {
    font-weight: 600;
  }
}

.prompt-body {
  position: relative;
  padding: 8px;

  .close-icon {
    position: absolute;
    font-size: 16px;
    top: -25px;
    right: 12px;
    color: $blue-mayday;
    cursor: pointer;
  }
}

.prompt-callout {
  text-align: left;
  height: 71px;
  padding: 6px;
  background-color: $grey-2-mayday;
  font-size: 14px;
  word-break: break-word;
  overflow-y: auto;

  .prompt-related {
    display: block;
    font-style: italic;
    font-size: 12px;
  }

  :deep() em {
    font-weight: 700;
  }
}

.prompt-footer {
  margin-top: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.prompt-count {
  font-size: 12px;
  color: $grey-7-mayday;
}
</style>
